import { render, staticRenderFns } from "./NotificationNew.vue?vue&type=template&id=4ffe134b&"
import script from "./NotificationNew.vue?vue&type=script&lang=js&"
export * from "./NotificationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports